/* eslint-disable react/no-array-index-key */
import { Fragment, Suspense, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Redirect, Route, Switch } from "react-router-dom";
import DashboardLayout from "src/layouts/DashboardLayout";
import LoaderAlif from "./components/Loader";

import React from "react";

const routesConfig = [
  {
    exact: true,
    path: "/",
    component: () => <Redirect to="/login" />
  },
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("src/views/pages/Error404View"))
  },
  {
    exact: true,
    path: "/login",
    component: lazy(() => import("src/views/auth/LoginView"))
  },

  {
    path: "/app",
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: "/app",
        component: lazy(() => import("./views/pages/Home"))
      },
      {
        exact: true,
        path: "/app/error-page",
        component: lazy(() => import("src/views/pages/ErrorPage"))
      },
      {
        exact: true,
        path: "/app/management",
        component: () => <Redirect to="/app/management/payment-transactions" />
      },

      {
        exact: true,
        path: "/app/management/home-screen",
        component: lazy(() => import("src/views/management/HomeScreen"))
      },

      // policies

      {
        exact: true,
        path: "/app/management/policies",
        component: lazy(() => import("src/views/management/PolicyListView"))
      },
      {
        exact: true,
        path: "/app/management/policies/create",
        component: lazy(() => import("src/views/management/PolicyCreateView"))
      },
      {
        exact: true,
        path: "/app/management/policies-group/create",
        component: lazy(() =>
          import("src/views/management/PoliciesGroupCreateView")
        )
      },

      // users
      {
        exact: true,
        path: "/app/management/users",
        component: lazy(() => import("src/views/management/UsersListView"))
      },
      {
        exact: true,
        path: "/app/management/userLogs",
        component: lazy(() => import("src/views/management/UserLogs"))
      },
      {
        exact: true,
        path: "/app/management/users/create",
        component: lazy(() => import("src/views/management/UserCreateView"))
      },
      {
        exact: true,
        path: "/app/management/users/:id",
        component: lazy(() => import("src/views/management/UserUpdateView"))
      },
      {
        exact: true,
        path: "/app/management/userLogs",
        component: lazy(() => import("src/views/management/UserLogs"))
      },
      // banknotes
      {
        exact: true,
        path: "/app/management/banknotes",
        component: lazy(() => import("src/views/management/BanknotesListView"))
      },

      // encashments
      {
        exact: true,
        path: "/app/management/encashments",
        component: lazy(() =>
          import("src/views/management/EncashmentsListView")
        )
      },

      {
        exact: true,
        path: "/app/management/encashments/:encashmentId/bills",
        component: lazy(() =>
          import("src/views/management/EncashmentBillsListView")
        )
      },

      {
        exact: true,
        path: "/app/management/reset-requests",
        component: lazy(() =>
          import("src/views/management/TerminalsResetRequests")
        )
      },

      {
        exact: true,
        path: "/app/management/encashments/:encashmentId/comments",
        component: lazy(() =>
          import("src/views/management/EncashmentCommentsListView")
        )
      },

      // cashout encashments
      {
        exact: true,
        path: "/app/management/cashout-encashments",
        component: lazy(() =>
          import("src/views/management/CashoutEncashmentsListView")
        )
      },

      {
        exact: true,
        path: "/app/management/cashout-encashment/:encashmentId/comments",
        component: lazy(() =>
          import("src/views/management/CashoutEncashmentCommentsListView")
        )
      },
      {
        exact: true,
        path: "/app/management/cashout-encashment/:encashmentId/transactions",
        component: lazy(() =>
          import("src/views/management/CashoutEncashmentTransactionsListView")
        )
      },
      // payments
      {
        exact: true,
        path: "/app/management/payments",
        component: lazy(() => import("src/views/management/PaymentsListView"))
      },

      // payment transactions
      {
        exact: true,
        path: "/app/management/payment-transactions",
        component: lazy(() =>
          import("src/views/management/PaymentTransactionsListView")
        )
      },

      // cashout
      {
        exact: true,
        path: "/app/management/cashout",
        component: lazy(() => import("src/views/management/CashoutListView"))
      },
      {
        exact: true,
        path: "/app/management/cashout-cassettes",
        component: lazy(() =>
          import("src/views/management/CashoutCassettesListView")
        )
      },
      {
        exact: true,
        path: "/app/management/cashout-transactions",
        component: lazy(() =>
          import("src/views/management/CashoutTransactions")
        )
      },
      {
        exact: true,
        path: "/app/management/cashout-balances",
        component: lazy(() => import("src/views/management/CashoutBalances"))
      },
      {
        exact: true,
        path: "/app/management/agent-balances",
        component: lazy(() => import("src/views/management/AgentBalancesListView"))
      },

      // monitoring
      {
        exact: true,
        path: "/app/management/monitoring",
        component: lazy(() => import("src/views/management/MonitoringListView"))
      },

      {
        exact: true,
        path: "/app/management/monitoring-new",
        component: lazy(() =>
          import("src/views/management/NewMonitoringListView")
        )
      },

      {
        exact: true,
        path: "/app/management/monitoring/create",
        component: lazy(() => import("src/views/management/TerminalCreateView"))
      },

      {
        exact: true,
        path: "/app/management/monitoring/create-new",
        component: lazy(() =>
          import("src/views/management/NewTerminalCreateView")
        )
      },
      {
        exact: true,
        path: "/app/management/monitoring/:terminalId/terminal-details",
        component: lazy(() =>
          import("src/views/management/TerminalDetailsView")
        )
      },
      {
        exact: true,
        path: "/app/management/monitoring-new/:terminalId/terminal-details",
        component: lazy(() =>
          import("src/views/management/NewTerminalDetailsView")
        )
      },
      {
        exact: true,
        path: "/app/management/balances",
        component: lazy(() => import("src/views/management/BalancesListView"))
      },
      {
        exact: true,
        path: "/app/management/bookkeeping",
        component: lazy(() =>
          import("src/views/management/BookkeepingListView")
        )
      },
      {
        exact: true,
        path: "/app/management/monitoring/:terminalId/terminal-details/create",
        component: lazy(() =>
          import("src/views/management/TerminalServiceCreateView")
        )
      },

      {
        exact: true,
        path: "/app/management/monitoring/:terminalId/terminal-details/edit",
        component: lazy(() =>
          import("src/views/management/TerminalServicesEditView")
        )
      },

      // logs
      {
        exact: true,
        path: "/app/management/monitoring/:terminalNum/logs",
        component: lazy(() => import("src/views/management/LogsListView"))
      },

      // services

      {
        exact: true,
        path: "/app/management/services",
        component: lazy(() => import("src/views/management/ServicesListView"))
      },
      {
        exact: true,
        path: "/app/management/services/create",
        component: lazy(() => import("src/views/management/ServiceCreateView"))
      },

      {
        exact: true,
        path: "/app/management/provider",
        component: lazy(() => import("src/views/management/ProviderListView"))
      },

      {
        exact: true,
        path: "/app/management/provider/:id",
        component: lazy(() =>
          import("src/views/management/ProviderListDetailView")
        )
      },

      {
        exact: true,
        path: "/app/management/category",
        component: lazy(() => import("src/views/management/CategoryListView"))
      },

      {
        exact: true,
        path: "/app/management/scheduled-command",
        component: lazy(() =>
          import("src/views/management/ScheduledCommandsListView")
        )
      },
      {
        exact: true,
        path: "/app/management/manual-encashment",
        component: lazy(() =>
          import("src/views/management/ManualEncashmentListView")
        )
      },
      {
        exact: true,
        path: "/app/management/terminal-buttons",
        component: lazy(() => import("src/views/management/TerminalButtons"))
      },
      {
        exact: true,
        path: "/app/management/offers",
        component: lazy(() => import("src/views/management/OffersListView"))
      },
      {
        exact: true,
        path: "/app/management/languages",
        component: lazy(() => import("src/views/management/LanguagesListView"))
      },
      {
        exact: true,
        path: "/app/management/postsListView",
        component: lazy(() => import("src/views/management/PostsListView"))
      },
      {
        exact: true,
        path: "/app/management/postsListView/cashout",
        component: lazy(() =>
          import("src/views/management/PostsListViewCashout")
        )
      },
      {
        exact: true,
        path: "/app/management/locations",
        component: lazy(() => import("src/views/management/TerminalsMapView"))
      },
      {
        exact: true,
        path: "/app/management/statuses",
        component: lazy(() =>
          import("src/views/management/StatusesHistoryView")
        )
      },

      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = (routes) =>
  routes ? (
    <Suspense fallback={<LoaderAlif />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    <ErrorBoundary
                      fallback={<Redirect to={"/app/error-page"} />}
                    >
                      {route.routes ? (
                        renderRoutes(route.routes)
                      ) : (
                        <Component {...props} />
                      )}
                    </ErrorBoundary>
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
